import { Navigate, useRoutes, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
// PATH_AFTER_LOGIN 暂未使用，路由中直接使用路径字符串
// utils
import { setGlobalNavigate } from '../auth/utils';
//
import {
  LoginPage,
  Page404,
  StatsGlobalPage,
  StatsRegionsPage,
  FactoryListPage,
  FactoryKeysPage,
  TenantsListPage,
  TenantDetailPage,
  FirmwareReleasesPage,
  FirmwareTargetsPage,
  FirmwareKeysPage,
} from './elements';
// ----------------------------------------------------------------------

export default function Router() {
  const navigate = useNavigate();

  // 设置全局导航函数
  useEffect(() => {
    setGlobalNavigate(navigate);
    console.log('✅ 全局导航函数已设置');
  }, [navigate]);

  return useRoutes([
    {
      path: '/',
      children: [
        { element: <Navigate to="/dashboard/stats/global" replace />, index: true },
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
      ],
    },
    {
      path: '/dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to="/dashboard/stats/global" replace />, index: true },
        {
          path: 'stats',
          children: [
            { element: <Navigate to="/dashboard/stats/global" replace />, index: true },
            { path: 'global', element: <StatsGlobalPage /> },
            { path: 'regions', element: <StatsRegionsPage /> },
          ],
        },
        {
          path: 'factory',
          children: [
            { element: <Navigate to="/dashboard/factory/list" replace />, index: true },
            { path: 'list', element: <FactoryListPage /> },
            { path: 'keys', element: <FactoryKeysPage /> },
          ],
        },
        {
          path: 'tenants',
          children: [
            { element: <Navigate to="/dashboard/tenants/list" replace />, index: true },
            { path: 'list', element: <TenantsListPage /> },
            { path: ':id', element: <TenantDetailPage /> },
          ],
        },
        {
          path: 'firmware',
          children: [
            { element: <Navigate to="/dashboard/firmware/targets" replace />, index: true },
            { path: 'releases', element: <FirmwareReleasesPage /> },
            { path: 'targets', element: <FirmwareTargetsPage /> },
            { path: 'keys', element: <FirmwareKeysPage /> },
          ],
        },
      ],
    },
    {
      element: <CompactLayout />,
      children: [{ path: '404', element: <Page404 /> }],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
